<template>
  <div class="tags-content">
    <el-tag
      :key="tag"
      v-for="tag in tagsArray"
      closable
      :disable-transitions="false"
      @close="handleClose(tag)">
      <span>{{ tag }}</span>
    </el-tag>
    <el-autocomplete
      class="tags-autocomplete"
      v-model="tagName"
      :fetch-suggestions="querySearchAsync"
      placeholder="请输入内容"
      placement="bottom"
      :popper-append-to-body="false"
      :trigger-on-focus="false"
      :select-when-unmatched="true"
      @select="handleSelect">
    </el-autocomplete>
  </div>
</template>

<script>
import { getTagsList } from '@/api/set.js'
export default {
  name: 'tagsTable',
  props: ['value', 'modelId'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      tagName: '',
      loading: false,
      tagsArray: []
    }
  },
  watch: {
    value: function (val) {
      this.tagsArray = val
    }
  },
  computed: {
  },
  methods: {
    tagsChange() {
      this.$emit('change', this.tagsArray)
    },
    querySearchAsync(queryString, cb) {
      let nilArray = []
      if (queryString === '') {
        cb(nilArray)
        return
      }
      let params = {
        limit: 10,
        page: 1,
        modelId: this.modelId,
        name: queryString,
        groupId: 0
      }
      getTagsList(params).then(res => {
        let array = []
        for (let item of res.data.result.list) {
          array.push({
            value: item.name
          })
        }
        let tmpArray = []
        for (let key in array) {
          let index = this.tagsArray.indexOf(array[key].value)
          if (index === -1) {
            tmpArray.push({value: array[key].value})
          }
        }
        let arrays = [
          {
            value: '未发现' + this.tagName + '(回车可以添加新标签)'
          }
        ]
        if (tmpArray.length === 0) {
          cb(arrays)
        } else {
          cb(tmpArray)
        }
      })
    },
    handleSelect(item) {
      item.value = item.value.replace(/\s+/g, '')
      if (item.value === '') {
        _g.toastMsg('error', '请输入内容')
        this.tagName = ''
        return
      }
      let itemTmp = item.value.replace('(回车可以添加新标签)', '')
      let itemTmp1 = itemTmp.replace('未发现', '')
      for (let one of this.tagsArray) {
        if (itemTmp1 === one) {
          _g.toastMsg('error', '请勿重复添加标签')
          this.tagName = ''
          return
        }
      }
      this.tagName = ''
      if (item.value.search('(回车可以添加新标签)') !== -1) {
        let tmpStr = item.value.replace('(回车可以添加新标签)', '')
        let tmpStr1 = tmpStr.replace('未发现', '')
        this.tagsArray.push(tmpStr1)
      } else {
        this.tagsArray.push(item.value)
      }
      this.$emit('change', this.tagsArray)
    },
    handleClose(item) {
      let index = this.tagsArray.indexOf(item)
      this.tagsArray.splice(index, 1)
      this.$emit('change', this.tagsArray)
    }
    // remoteMethod(query) {
    //   if (query !== '') {
    //    let params = {
    //       limit: 10,
    //       page: 1,
    //       modelId: this.modelId,
    //       name: query,
    //       groupId: 0
    //     }
    //     this.loading = true
    //     getTagsList(params).then(res => {
    //       this.loading = false
    //       if (res.data.code === '200' ) {
    //         this.options = res.data.result.list
    //       }
    //     })
    //   } else {
    //     this.options = []
    //   }
    // }
  },
  mounted() {
  },
  created() {
    this.tagsArray = this.value
  }
}
</script>

<style scoped>
.tags-content {
  margin-bottom: 20px;
}
.tags-autocomplete {
  width: 100%;
}
.tags-autocomplete .el-input__inner {
  width: 370px!important; 
}
.el-tag + .el-tag {
  margin-left: 10px;
  margin-bottom: 5px;
}
</style>
